import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./http";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Never burn retries on a 404 or a validation error.
        if (error instanceof ApiError && !error.isRetryable) return false;
        return failureCount < 2;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: {
      retry: false,
    },
  },
});

/** Centralised cache keys — prevents typo-driven cache misses. */
export const qk = {
  projects: (query?: unknown) => ["projects", query ?? {}] as const,
  project: (id: string) => ["project", id] as const,
  turnkey: (query?: unknown) => ["turnkey", query ?? {}] as const,
  turnkeyItem: (id: string) => ["turnkey-item", id] as const,
  plans: (query?: unknown) => ["plans", query ?? {}] as const,
  /**
   * Keyed by licence too: the locked and unlocked payloads for one plan are
   * different documents, and sharing a key would serve a buyer the redacted
   * version from cache (or worse, hand the redacted copy to a buyer and then
   * never refetch).
   */
  plan: (id: string, licenceId?: string) => ["plan", id, licenceId ?? null] as const,
  blog: (query?: unknown) => ["blog", query ?? {}] as const,
  blogPost: (id: string) => ["blog-post", id] as const,
  services: () => ["services"] as const,
  service: (id: string) => ["service", id] as const,
  jobs: (query?: unknown) => ["jobs", query ?? {}] as const,
  job: (id: string) => ["job", id] as const,
  search: (query?: unknown) => ["search", query ?? {}] as const,
};
